<script setup>
/**
 * 应用根组件
 *
 * 功能说明：
 * - 配置 Ant Design Vue 国际化（中文）
 * - 挂载全局页面加载进度条
 */
import 'dayjs/locale/zh-cn'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import PageProgress from '@/components/PageProgress.vue'
</script>

<template>
  <a-config-provider :locale="zhCN">
    <!-- 页面加载进度条 -->
    <PageProgress />
    <!-- 路由视图 -->
    <router-view />
  </a-config-provider>
</template>

<style lang="scss" scoped></style>
